var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCilantro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 288,
    height: 288
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#414141",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.48,130.77C26.83,110.15,80,150.23,80,150.23s-20.14-19.12-8.13-31.81c36.81-14.63,45,41.23,45,41.23s4.5,28.61,12.3,28c15.53-1.26,14.38-35.3-1.21-50-24.07-22.71-46.64-52.32-24-68.82C124,54.15,136.52,85.72,139.11,93.1c.32,1,.51,1.52.51,1.52s-.18-.57-.51-1.52c-3-9.21-17.85-57.71,2.66-65.42,22.67-8.52,28.46,21.8,28.46,21.8s-.35-44,22.88-40c23-1.3,16.34,64.61,16.34,64.61s10.26-32.78,29-18.38-5.67,52.07-5.67,52.07,14.84-12.31,20.44-3.37c10.22,24.71-62.78,59.43-70.42,60.35-15.67,1.89-28.79,8.22-22.56,18,8,12.51,20.36-5.48,20.36-5.48s40.5-39.1,68.31-13.07c12.37,27.31-30.85,26.11-28.2,36.37,5,19.33,35.06-40.54,57.66-1.33,2.61,27.1-38.14,28.56-50.63,28.38-2.23-.11-3.59-.11-3.59-.11s1.34.08,3.59.11c11.63.59,47.13,4.16,38.57,25.76-6.36,16.06-21.58,8.26-32.12.12-4.71-5.73-5.61-12.36-11-9.91-16.64,7.56,25.31,8.63,11.27,30.21C215.21,297.35,177.2,230,160.09,225s-15.54-.46-24.55,24.85c-5.43,15.27-12.7,20.12-19.24,23.56l0-.06c6.91-6.71,12.35-17.26,14.44-29.72,3.86-23.05-6.43-45.68-21.44-48.19-5.64-.94-11.33.83-16.43,4.63a16.12,16.12,0,0,0-5.37,4.72c-5,6.78-20.43,17.65-27.13,12.38C48.63,204,77.8,195.47,77.52,189.22s-9.31-5-19.49.95-23.84,34.41-37.29,20.55C9.41,199,27.41,188.44,33.33,185.41c1.13-.53,1.79-.87,1.79-.87s-.68.31-1.79.87c-8.88,4.19-19.87-.9-21.78-15.08-1.36-16.71,29.65-10.1,29.65-10.1s-43.08-8.84-28.72-29.46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilantro);
export default __webpack_public_path__ + "static/media/cilantro.d45e29ac3b41db059d79f3ce5acaea85.svg";
export { ForwardRef as ReactComponent };